export const BillingInfo = {
  location: 'HC - Fullstack Labs',
  address: 'HC - 12345 Main Street',
  address_line_2: '',
  city: 'HC - Granite Bay',
  state: 'CA',
  zip: '95746',
  country: 'USA'
};

export const Notifications = [
  {
    id: 1,
    user: 'HC - Brian Smith',
    emailAddress: 'example@email.com',
    emailAddressNotifications: 'none'
  },
  {
    id: 2,
    user: 'HC - Sample Person A',
    emailAddress: 'example@email.com',
    emailAddressNotifications: 'none'
  },
  {
    id: 3,
    user: 'HC - Sample Person B',
    emailAddress: 'example@email.com',
    emailAddressNotifications: 'none'
  }
];

export const EmptyNotification = {
  id: null,
  user: '',
  phoneNumber: '',
  phoneNumberNotifications: [],
  emailAddress: '',
  emailAddressNotifications: []
};
